<div class="text-xl font-bold mb-4">{{ 'ONB_CLIENT_LIST.ONBOARDING' | translate }}</div>
<app-tabs [tabs]="onboardingTabs"></app-tabs>
<router-outlet></router-outlet>